<div class="si-rich-text {{styleClass}}" [class.disabled]="disabled"
     [class.invalid]="formModel?.invalid && (formModel.dirty || formModel.formDirective?.submitted || validationExternalErrorText)">
  <div>
    <div *ngIf="!hideLabel" class="si-rich-text_label">
      <si-label [text]="text"
                [tooltipText]="tooltipText"
                [tooltipPosition]="tooltipPosition"
                [tooltipIcon]="tooltipIcon"
                [tooltipStyleClass]="tooltipStyleClass"
                [tooltipEscape]="tooltipEscape"
                [forceShowTooltipIcon]="forceShowTooltipIcon"
                (tooltipIconClick)="onClickTooltipIcon($event)"
                forId="si-rich-text_editor-{{id}}"
      ></si-label>
    </div>
    <div>
      <si-validation-element #validationElement
                             [formModel]="formModel"
                             [showErrorText]="!showRuleErrorOutsideIcon"
                             (errorTextChange)="validationErrorText = $event"
                             class="si-rich-text_validation"
      ></si-validation-element>
    </div>
  </div>
  <div class="si-rich-text_textarea" [class.si-rich-text_resize]="resize" siProvideParentForm>
    <p-editor #textEditor
              #formModel="ngModel"
              id="si-rich-text_editor-{{id}}"
              [name]="name"
              placeholder="{{disabled ? '' : (placeholder | translate)}}"
              [(ngModel)]="model"
              (onTextChange)="onChangeModel($event)"
              [readonly]="disabled"
              [disabled]="disabled"
              siValidation="{{rule}}"
              [siValidationElement]="validationElement"
              [siValidationExternalErrorText]="validationExternalErrorText">
    </p-editor>
  </div>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
